<template>
  <div>
    <b-row>
      <b-col>
        <h4>収支サマリ一覧</h4>
      </b-col>
    </b-row>
    <b-row class="component-margin-half">
      <b-col md="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
          :items="items" :fields="fields"
          :current-page="currentPage"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="totalAmount" slot-scope="row">
            <div><label>{{formatPrice(row.item['totalAmount'])}}</label></div>
          </template>
          <template slot="totalBilledAmountThisMonth" slot-scope="row">
            <div><label>{{formatPrice(row.item['totalBilledAmountThisMonth'])}}</label></div>
          </template>
          <template slot="totalCarryOverAmount" slot-scope="row">
            <div><label>{{formatPrice(row.item['totalCarryOverAmount'])}}</label></div>
          </template>
          <template slot="inputDataCsv" slot-scope="row">
            <b-button @click="displayCsvUploadPopup(row)" size="sm" variant="danger">upload(CSV)</b-button>
            <b-button @click="downloadCsvFile(row)" size="sm" :disabled="row.item['csvUrl'] == null || row.item['csvUrl'] === ''" variant="primary">download(CSV)</b-button>
          </template>
          <template slot="inputDataPdf" slot-scope="row">
            <b-button @click="displayPdfUploadPopup(row)" size="sm" variant="danger">upload(PDF)</b-button>
            <b-button @click="downloadPdfFile(row)" size="sm" :disabled="row.item['pdfUrl'] == null || row.item['pdfUrl'] === ''" variant="primary">download(PDF)</b-button>
          </template>
        </b-table>
        <b-modal ref="confirmMessage" ok-only hide-header>
          <div class="text-center"><label>{{confirmMessage}}</label></div>
        </b-modal>
        <b-modal ref="uploadCsvPopup" title="CSVファイルアップロード" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow" hide-header-close hide-footer>
          <input type="file" @change="onFileChange" />
          <b-button size="md" @click="uploadCsvFile()" :disabled="selectedFile == null || selectedFile === ''" variant="primary">ファイルをアップロードする</b-button>
        </b-modal>
        <b-modal ref="uploadPdfPopup" title="PDFファイルアップロード" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" no-close-on-backdrop=false no-close-on-esc=false content-class="shadow" hide-header-close hide-footer>
          <input type="file" @change="onFileChange" />
          <b-button size="md" @click="uploadPdfFile()" :disabled="selectedFile == null || selectedFile === ''" variant="primary">ファイルをアップロードする</b-button>
        </b-modal>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col md="6">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import DatePicker from '@/components/common/DatePicker';
import * as api from '@/api';

export default {
  props: {
    items: {
      'default': [],
    },
    // productFilter: {
    //   'default': '',
    // },
    // sizeTypeFilter: {
    //   'default': '8',
    // },
    // inboundFilter: {
    //   'default': '0',
    // },
  },
  mixins: [BaseComponent],
  data() {
    return {
      fields: [
        { key: 'refMonth', label: '対象月', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'category', label: 'カテゴリ', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'name', label: '名称', sortable: true, variant: 'base', class: 'table-lw20' },
        { key: 'totalAmount', label: '利用額合計', sortable: false, variant: 'base', class: 'table-rw10' },
        { key: 'totalBilledAmountThisMonth', label: '当月請求額', sortable: false, variant: 'base', class: 'table-rw10' },
        { key: 'totalCarryOverAmount', label: '翌月繰越額', sortable: false, variant: 'base', class: 'table-rw10' },
        { key: 'inputDataCsv', label: 'データ(CSV)', sortable: false, variant: 'warning', class: 'table-cw10' },
        { key: 'inputDataPdf', label: 'データ(PDF)', sortable: false, variant: 'warning', class: 'table-cw10' },
        { key: 'viewDetail', label: '明細', sortable: false, variant: 'warning', class: 'table-cw10' },
        { key: 'statusJp', label: 'Status', sortable: false, variant: 'success', class: 'table-lw10' },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activate: false,
      editRowKey: null,
      selectedFile: null,
      regId: null,
      editItem: {},
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      confirmMessage: ''
    };
  },
  // computed: {
  //   filteredItems() {
  //       let filteredItems = this.items.filter(item => {
  //        return (((this.productFilter === '' || (item.asin !== null && item.asin.toUpperCase().indexOf(this.productFilter.toUpperCase()) !== -1) ||
  //                 (item.sku !== null && item.sku.toUpperCase().indexOf(this.productFilter.toUpperCase()) !== -1) ||
  //                 (item.janCode !== null && item.janCode.toUpperCase().indexOf(this.productFilter.toUpperCase()) !== -1) ||
  //                 (item.productNameEn !== null && item.productNameEn.toUpperCase().indexOf(this.productFilter.toUpperCase()) !== -1)) &&
  //                (this.inboundFilter === '0' || (this.inboundFilter !== null && this.inboundFilter === '1' && item.inboundQuantity === item.purchaseQuantity) ||
  //                (this.inboundFilter !== null && this.inboundFilter === '2' && item.inboundQuantity !== item.purchaseQuantity)) &&
  //                (this.sizeTypeFilter === '8' || (item.weightType !== null && item.weightType === this.sizeTypeFilter))
  //             ));
  //       });
  //     this.totalRows = filteredItems.length;
  //     this.currentPage = 1;
  //     return filteredItems;
  //   },
  // },
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    // CSVファイルアップロード
    displayCsvUploadPopup(row){
      this.selectedFile = '';
      this.regId = row.item.id;
      this.$refs.uploadCsvPopup.show();
    },
    uploadCsvFile() {
      var itemArray = [];
      itemArray.push(this.selectedFile);
      itemArray.push(this.regId);
      this.$emit('uploadCsvFile', itemArray);
      this.$refs.uploadCsvPopup.hide();
    },
    // PDFファイルアップロード
    displayPdfUploadPopup(row){
      this.selectedFile = '';
      this.regId = row.item.id;
      this.$refs.uploadPdfPopup.show();
    },
    uploadPdfFile() {
      var itemArray = [];
      itemArray.push(this.selectedFile);
      itemArray.push(this.regId);
      this.$emit('uploadPdfFile', itemArray);
      this.$refs.uploadPdfPopup.hide();
    },
    downloadCsvFile(row) { this.$emit('downloadFile', row.item.csvUrl); },
    downloadPdfFile(row) { this.$emit('downloadFile', row.item.pdfUrl); },
  },
};
Vue.component('date-picker', DatePicker);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}
.it_max-width{
  width: 100%;
}
table > thead > tr > th {
  text-align: center!important;
}
.image {
  align-content: center;
  height: 4rem;
  width: 4rem; 
}
th.table-base {
    background-color: aliceblue!important;
}
th.table-ans {
    background-color: beige!important;
}
.matome-status-mark .custom-control-input:disabled:checked~.custom-control-label:before {
    background-color: #ff0000cf;
}
.mark-red {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}
.mark-red2 {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.5rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
}
@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw4-min  { min-width:  4rem; text-align:left; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
